import { Flex, PinpointIcon, Text, theme } from '@/components';
import { useNavigateToPinpoint } from '@/features/comment/hooks/navigate-to-pinpoint';
import type { FC, PropsWithChildren } from 'react';
import { usePinpointDisplayName } from '../../hooks/pinpoint-display-name';
import type { PinpointMappingType } from '../../models/pinpoint';
import { usePinpoint } from './PinpointProvider';

type Props = {
  pinpoint: PinpointMappingType;
  showIcon?: boolean;
  color?: 'normal' | 'secondary';
  size?: 'small' | 'medium';
} & (
  | {
      navigateOnClick?: false;
      objectId?: never;
      commentId?: never;
    }
  | {
      navigateOnClick: true;
      objectId: string;
      commentId: string;
    }
);

export const PinpointDisplay: FC<PropsWithChildren<Props>> = ({
  pinpoint,
  size,
  color,
  showIcon,
  navigateOnClick,
  objectId,
  commentId,
}) => {
  const { token } = theme.useToken();
  const { resetPinpoint } = usePinpoint();
  const navigateToPinpoint = useNavigateToPinpoint();

  const { label, isLoading } = usePinpointDisplayName(pinpoint);
  return (
    <Flex
      gap={4}
      onClick={() => {
        if (navigateOnClick) {
          resetPinpoint();
          navigateToPinpoint({ pinpoint, commentId, objectId });
        }
      }}
      style={{ cursor: navigateOnClick ? 'pointer' : 'default' }}
    >
      {showIcon && (
        <PinpointIcon
          style={{ fill: navigateOnClick ? token.colorPrimary : undefined }}
        />
      )}
      {!isLoading && (
        <Text
          text={label}
          weight="regular"
          color={navigateOnClick ? 'primary' : color}
          variant={size === 'small' ? 'footnote' : 'body'}
        />
      )}
    </Flex>
  );
};
